import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import img from "@/assets/protocolli.jpg";
import { Building, GraduationCap, Landmark, Scale } from "lucide-react";

const partners = [
  { i: Landmark, t: "Presidenza del Consiglio", d: "Segretariato Generale e Ministeri" },
  { i: Building, t: "Regioni ed Enti Pubblici", d: "Accordi territoriali per l'accessibilità" },
  { i: GraduationCap, t: "Università", d: "Ricerca e didattica sull'Universal Design" },
  { i: Scale, t: "Ordini Professionali", d: "Consigli e Ordini di tecnici e progettisti" },
];

const Protocolli = () => (
  <>
    <SEO
      title="Protocolli d'Intesa — FIABA ETS"
      description="FIABA ha sottoscritto Protocolli d'Intesa con la Presidenza del Consiglio, Ministeri, Regioni, Università e Ordini Professionali per promuovere l'abbattimento delle barriere."
      path="/protocolli-intesa"
    />
    <PageHero
      eyebrow="Protocolli d'Intesa"
      title="Una rete istituzionale per l'accessibilità"
      subtitle="Accordi finalizzati alla promozione di iniziative per il miglioramento della qualità della vita di ogni persona."
    />
    <section className="section-padding">
      <div className="container-narrow grid lg:grid-cols-2 gap-12 items-center">
        <img src={img} alt="Firma protocollo d'intesa istituzionale" className="rounded-lg shadow-elegant" loading="lazy" />
        <div className="space-y-5 leading-relaxed text-foreground/90">
          <p>FIABA ha sottoscritto importanti Protocolli d'Intesa con il <strong>Segretariato Generale della Presidenza del Consiglio dei Ministri</strong>, con diversi Ministeri, Regioni, Enti pubblici e privati, Università, Ordini e Consigli Professionali, e altre istituzioni.</p>
          <p>Tutti gli accordi sono finalizzati alla promozione di iniziative per l'abbattimento delle barriere architettoniche e per il miglioramento della qualità della vita di ogni persona.</p>
        </div>
      </div>
      <div className="container-narrow mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {partners.map((p) => (
          <div key={p.t} className="bg-card p-6 rounded-lg shadow-soft border border-border text-center">
            <p.i className="w-10 h-10 text-secondary mx-auto mb-3" />
            <h3 className="font-serif font-bold text-primary mb-1">{p.t}</h3>
            <p className="text-sm text-muted-foreground">{p.d}</p>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default Protocolli;
